import { $path } from 'safe-routes';
import { PaymentsContentPanel } from '~/components/payments-content-panel.tsx';
import type { HomeReservation } from '~/routes/_index/fetch-home-reservations.server.ts';
import { QuickActionCard } from './quick-action-card.tsx';
import { ReservationsSection } from './reservations-section.tsx';
import type { VenueOption } from './resolve-selected-venue.ts';
import { VenueSelector } from './venue-selector.tsx';

type HomePanelProps = {
  venues: VenueOption[];
  selectedVenueId: string | null;
  selectedVenueName: string;
  reservations: HomeReservation[];
  reservationsHasMore: boolean;
  locale?: string | null;
  timezone?: string | null;
};

export const HomePanel = ({
  venues,
  selectedVenueId,
  selectedVenueName,
  reservations,
  reservationsHasMore,
  locale,
  timezone,
}: HomePanelProps) => {
  return (
    <PaymentsContentPanel overlapHeader>
      <div className="flex shrink-0 items-center justify-center px-4 pt-8 pb-6">
        <VenueSelector
          venues={venues}
          selectedVenueId={selectedVenueId}
          selectedVenueName={selectedVenueName}
        />
      </div>

      <div className="grid shrink-0 grid-cols-2 gap-3 px-4 pt-4">
        <QuickActionCard
          action={{ id: 'send-paylink', label: 'Send Paylink' }}
          to={$path('/paylink/new')}
          className="min-w-0"
        />

        <QuickActionCard
          action={{ id: 'charge-card', label: 'Charge a Card' }}
          to={$path('/reservations')}
          className="min-w-0"
        />
      </div>

      <ReservationsSection
        initialReservations={reservations}
        initialHasMore={reservationsHasMore}
        selectedVenueId={selectedVenueId}
        locale={locale}
        timezone={timezone}
      />
    </PaymentsContentPanel>
  );
};
